import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag } from 'types';
import { EUSSIndicator } from '../../../atoms/icons/EUSSIndicator';
import { useTranslation } from "react-i18next";

export const EussPendingTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  return (
    <Tooltip hasArrow placement="bottom" label={<EUSSPendingHover />} data-selector="tag-euss-pending">
      <Tag size="xs" variant="solid" {...tagProps}>
        <Box mr="0.5">
          <EUSSIndicator />
        </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const EUSSPendingHover = () => {
    const { t } = useTranslation('common');
  return <>{t('common:applyingForEuSettlementScheme')}</>;
};
